module.exports = "/images/sx.svg?aec013e4ed7fc046c1f5e28918bc4492";